import { AlertCircleIcon } from 'lucide-react';
import { PROVISIONAL_HINT } from '../../core/rules/usage';

/**
 * Klein uitroepteken bij een gebruiksduur die nog een voorlopige schatting is. Muis: tooltip via
 * `title`; schermlezer: dezelfde zin als label. Bewust stil (muted), het is een herinnering, geen fout.
 */
export function ProvisionalMark({
  className = ''
}: {
  className?: string;
}) {
  return <span role="img" aria-label={PROVISIONAL_HINT} title={PROVISIONAL_HINT} className={`inline-flex shrink-0 align-middle text-clay ${className}`} data-id="element-5402" data-mp="35wq5nx0g1oyt">
      <AlertCircleIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-5403" data-mp="3au03o11wf8y9" />
    </span>;
}